import * as Const from '../constants/actionConstants';

import SubFormIsLoading from '../interfaces/actions/SubFormIsLoading';
import AvailablePackage from '../interfaces/AvailablePackage';
import SubChangeAvailablePackage from '../interfaces/actions/SubChangeAvailablePackage';
import SubChangeAvailableProduct from '../interfaces/actions/SubChangeAvailableProduct';
import SubFormError from '../interfaces/actions/SubFormError';

export const subChangeAvailableProduct = (availableProduct: string[]): SubChangeAvailableProduct => {
  return {
    type: Const.SUB_CHANGE_AVAILABLE_PRODUCT,
    availableProduct,
  };
};
export const subChangeAvailablePackage = (availablePackage_: AvailablePackage[]): SubChangeAvailablePackage => {
  return {
    type: Const.SUB_CHANGE_AVAILABLE_PACKAGE,
    availablePackage_,
  };
};

export const subFormError = (error: boolean): SubFormError => {
  return {
    type: Const.SUB_FORM_ERROR,
    error,
  };
};

export const subFormIsLoading = (isLoading: boolean): SubFormIsLoading => {
  return {
    type: Const.SUB_IS_LOADING_FORM,
    isLoading,
  };
};
